import { adminPath } from '@/core/utils/env.utils';

export const USER_ENDPOINTS = {
  USERS: adminPath('/users'),
  CREATE_USER: adminPath('/users'),
  USER_BY_ID: (id: string) => adminPath(`/users/${id}`),
  UPDATE_USER: (id: string) => adminPath(`/users/${id}`),
  DELETE_USER: (id: string) => adminPath(`/users/${id}`),
  RESET_PASSWORD: (id: string) => adminPath(`/users/${id}/reset-password`),
} as const;